<template>
    <div class="integral-rule">
        <div class="header-banner">
            <img src="~@/assets/images/MyIntergral/integral-rule/banner.png" alt="">
        </div>
        <div class="integral-content">
            <header class="content-header"></header>
            <section class="rule-item sign-in">
                <img class="title" src="~@/assets/images/MyIntergral/integral-rule/sign-in.png" alt="">
                <img class="content" src="~@/assets/images/MyIntergral/integral-rule/sign-in-info.png" alt="">
                <div class="text">
                    用户进入鹿路通APP进入积分中心签到，每天<br />
                    签到获得2积分，连续7天签到，&nbsp;第7天起每天<br />获
                    得5积分，如果中断则重新计时。
                </div>
            </section>

            <section class="rule-item mt-20 novice">
                <img class="title" src="~@/assets/images/MyIntergral/integral-rule/novice.png" alt="">
                <div class="task-item">
                    <img class="img-class" src="~@/assets/images/MyIntergral/integral-rule/l2.png" alt="">
                    <div class="task-item-text">用户完成<strong>L2认证</strong>，获得2积分；</div>
                </div>
                <div class="task-item">
                    <img class="img-class" src="~@/assets/images/MyIntergral/integral-rule/l3.png" alt="">
                    <div class="task-item-text">用户完成<strong>L3认证</strong>，获得3积分；</div>
                </div>
                <div class="task-item">
                    <img class="img-class" src="~@/assets/images/MyIntergral/l4.png" alt="">
                    <div class="task-item-text">用户完成<strong>L4认证</strong>，获得10积分；</div>
                </div>
            </section>

            <section class="rule-item daily">
                <img class="title" src="~@/assets/images/MyIntergral/integral-rule/daily.png" alt="">
                <div class="daily-item" v-for="(item, i) in dailyList" :key="i">
                    <img :src="item.imgUrl" alt="">
                    <div class="text" v-html="item.text"></div>
                </div>
            </section>
        </div>

        <div class="other-explain">
            <header class="content-header"></header>
            <div class="content">
                <div class="explain-item">
                    <span>1</span>
                    <div class="text">鹿路通有权确定及调整积分获取规则；</div>
                </div>
                <div class="explain-item">
                    <span>2</span>
                    <div class="text">为保证积分正常使用，请将鹿路通APP更新至最新版；</div>
                </div>
                <div class="explain-item">
                    <span>3</span>
                    <div class="text">如用户账号注销使用，则鹿路通将同步注销该用户账号内积分相关使用权益；</div>
                </div>
                <div class="explain-item">
                    <span>4</span>
                    <div class="text">以上积分规则<div
                            style="display: inline-block;color: rgba(255, 0, 15, 1); font-weight: 700">自 年 月 日（待确认）
                        </div>生效。</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dailyList: [
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/car.png'),
                    text: "用户在鹿路通APP里使用<strong>扫码乘车</strong>获<br />得1积分，每天最高获得4积分；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/bus-select.png'),
                    text: "用户在鹿路通APP里使用<strong>公交查询</strong>获<br />得１积分，每天可以获得１次；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/wash-bus.png'),
                    text: "用户在鹿路通APP里使用<strong>收藏线路站<br />点</strong>获得１积分，每天可以获得１次；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/services robot.png'),
                    text: "用户在鹿路通APP里使用<strong>智能客服</strong>获<br />得１积分，每天可以获得１次；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/time.png'),
                    text: "用户使用<strong>鹿路通APP累计10分钟</strong>，每<br />天可以获得2积分；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/epidemic situation.png'),
                    text: "用户使用鹿路通APP里<strong>疫情相关的应<br />用</strong>获得１积分，每天可以获得３次；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/article.png'),
                    text: "用户在鹿路通APP里<strong>浏览文章</strong>获得１<br />积分，每天可以获得３次；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/share.png'),
                    text: "用户在鹿路通APP里<strong>分享文章</strong>获得１<br />积分，每天可以获得３次；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/market.png'),
                    text: "用户在鹿路通APP里<strong>浏览商城</strong>满5分<br />钟获得1积分，每天可以获得1次；",
                },
                {
                    imgUrl: require('@/assets/images/MyIntergral/integral-rule/shopping.png'),
                    text: "用户在鹿路通APP里<strong>商城购物</strong>，确认<br />收货后可以获得2积分。",
                },
            ]
        }
    },

    components: {},

    methods: {}
}
</script>

<style scoped lang="scss">
.mt-20 {
    margin-top: 2.5rem;
}

.integral-rule {
    position: relative;
    min-height: 100vh;
    width: 100vw;
    background: url(~@/assets/images/MyIntergral/integral-rule/bg.png) no-repeat center center;
    background-size: 100% 100%;
    overflow: scroll;

    .header-banner {
        position: absolute;
        height: 15.125rem;
        width: 100%;
        z-index: 0;

        img {
            height: 100%;
            width: 100%;
        }
    }

    .integral-content {
        position: relative;
        margin: 10.75rem 2rem 3.25rem;
        padding: 4.5rem 2.125rem;
        min-height: 100vh;
        background: url('~@/assets/images/MyIntergral/integral-rule/integral-content-bg.png') no-repeat center center;
        background-size: 100% 100%;
        z-index: 1;

        .content-header {
            position: absolute;
            left: 50%;
            top: -5rem;
            height: 7.5rem;
            width: 32.5rem;
            background: url('~@/assets/images/MyIntergral/integral-rule/content-header.png') no-repeat center center;
            background-size: 100% 100%;
            transform: translateX(-50%);
        }

        .rule-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .title {
                height: 4rem;
            }


            .task-item {
                display: flex;
                align-items: center;
                margin-bottom: 2.75rem;
                width: 34.875rem;
                height: 4rem;
                background: #F3FFF8;
                box-shadow: inset 0rem 0rem 1rem rgba(10, 177, 137, 0.35);
                border-radius: 3.125rem;
                font-size: 1.75rem;
                color: #22787C;

                .img-class {
                    margin-right: 1.5rem;
                    height: 4rem;
                    width: 4rem;
                }
            }

            .daily-item {
                position: relative;
                margin-bottom: .875rem;
                margin-left: 1.25rem;
                width: 33.875rem;
                padding: 1.125rem 0 1.125rem 0;
                padding-left: 3.125rem;
                background: #F3FFF8;
                box-shadow: inset 0px 0px 1rem rgba(10, 177, 137, 0.35);
                border-radius: .875rem;
                font-size: 1.75rem;
                color: #22787C;

                img {
                    position: absolute;
                    top: 50%;
                    left: -2rem;
                    height: 4rem;
                    transform: translateY(-50%);
                }
            }

        }

        .novice,
        .daily {
            .title {
                margin-bottom: 2rem;
            }
        }

        .sign-in {
            .content {
                margin-top: 1.625rem;
                height: 17.25rem;
            }

            .text {
                margin-top: 1.25rem;
                font-size: 1.75rem;
                color: #22787C;
                line-height: 2.5337rem;
            }
        }
    }

    .other-explain {
        position: relative;
        margin: 6.25rem 2rem 3.25rem;
        padding: 7rem 3.5rem 2.625rem;
        background: #FFFBFB;
        border: 6px solid #0AB189;
        box-shadow: inset 0px 0px 8px #B9F6F4;
        backdrop-filter: blur(22px);
        /* Note: backdrop-filter has minimal browser support */

        border-radius: 18px;

        .content-header {
            position: absolute;
            left: 50%;
            top: -5rem;
            height: 7.5rem;
            width: 32.5rem;
            background: url(~@/assets/images/MyIntergral/integral-rule/explain-header.png) no-repeat center center;
            background-size: 100% 100%;
            transform: translateX(-50%);
        }

        .content {
            .explain-item {
                display: flex;
                align-items: flex-start;
                margin-bottom: 1.5rem;

                span {
                    display: inline-block;
                    height: 2.25rem;
                    width: 2.25rem;
                    background: #22787C;
                    box-shadow: inset 0px 0px 6px rgba(108, 214, 161, 0.35);
                    border-radius: 50%;
                    font-size: 1.75rem;
                    font-weight: 700;
                    color: #fff;
                    text-align: center;
                    line-height: 2.25rem;
                }

                .text {
                    margin-left: 1.25rem;

                    flex: 1;
                    color: #22787C;
                    font-size: 1.75rem;
                    line-height: 2.5337rem;
                }
            }
        }
    }
}
</style>